import { useMemo } from "react";
import type { User } from "./types.ts";

export function useUser() {
    const user = useMemo<User | null>(() => {
        const userData = localStorage.getItem("userData");

        if (!userData) return null;

        try {
            return JSON.parse(userData);
        } catch (error) {
            console.error("Failed to parse user data from localStorage:", error);
            return null;
        }
    }, []);

    return user
}